/*
 * Szerencsekerék (snippets/kg-wheel.liquid): Voovo's discount wheel (voovostudy-web,
 * src/components/partner-lp/discount-wheel, the spin-only wheel without the study question) in Kenguru's colours.
 *   - the dialog: the wheel (pin pointer, two-tone slices, labels upright at rest, the Kenguru mark in the hub), the
 *     e-mail form, a 4.2 s spin onto the slice the SERVER drew, the code with Másolás and "Vásárolok";
 *   - the navbar's part, hanging from the header's lower edge: the tab with the mini wheel (opens the dialog; × hides
 *     it for 3 days) and, while a won code lives, the code bar (prize, code, expiry, Másolás, ×) or its small chip.
 * The platform's /api/wheel answers: config → { open, preview, config: { slices, texts, cookieDays } }; spin →
 * { slice, label, win, code, endsAt } or { error }; view → counts "shown" / "closed". No dependencies.
 */
(function () {
  'use strict';
  var script = document.querySelector('script[data-kg-wheel]');
  if (!script || window.__kgWheel) return;
  window.__kgWheel = true;
  var API = script.getAttribute('data-api');
  var PRIVACY = script.getAttribute('data-privacy') || '/pages/adatkezelesi-tajekoztato';
  var MARK = script.getAttribute('data-mark') || '';
  var SEEN_COOKIE = 'kg_wheel_seen';
  var WIN_KEY = 'kg_wheel_win';
  var TAB_HIDDEN_KEY = 'kg_wheel_tab_hidden';
  var BAR_HIDDEN_KEY = 'kg_wheel_bar_hidden';
  var NUDGE_KEY = 'kg_wheel_nudged';
  var TAB_HIDE_DAYS = 3;
  var SPIN_MS = 4200;
  var SPIN_TURNS = 5;
  var preview = /[?&]kgwheel=preview\b/.test(location.search);
  var config = null;

  // ---------- storage (any of it may be blocked: the wheel then acts as on a first visit) ----------
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    if (days <= 0) return;
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + Math.round(days * 86400) + '; path=/; SameSite=Lax';
  }
  function local(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }
  function session(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }
  function readWin() {
    try {
      var w = JSON.parse(local(WIN_KEY) || 'null');
      return w && w.code && w.until > Date.now() ? w : null;
    } catch (e) {
      return null;
    }
  }

  // ---------- the platform ----------
  function post(body) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' }).then(function (res) {
      return res.json().catch(function () {
        return { error: 'failed' };
      });
    });
  }
  function beacon(kind) {
    var body = JSON.stringify({ action: 'view', kind: kind });
    // text/plain needs no CORS preflight, so the beacon survives the page being left
    if (navigator.sendBeacon && navigator.sendBeacon(API, new Blob([body], { type: 'text/plain' }))) return;
    fetch(API, { method: 'POST', body: body, keepalive: true, credentials: 'omit' }).catch(function () {});
  }

  // ---------- helpers ----------
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  var SVG = 'http://www.w3.org/2000/svg';
  function svg(tag, attrs) {
    var n = document.createElementNS(SVG, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function fill(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (all, key) {
      return values[key] != null ? values[key] : all;
    });
  }
  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }
  // "ma 18:05", "holnap 12:25", else "nov. 12. 09:30"
  function until(at) {
    try {
      var d = new Date(at);
      var time = new Intl.DateTimeFormat('hu-HU', { hour: '2-digit', minute: '2-digit' }).format(d);
      var day = new Date();
      if (d.toDateString() === day.toDateString()) return 'ma ' + time;
      day.setDate(day.getDate() + 1);
      if (d.toDateString() === day.toDateString()) return 'holnap ' + time;
      return new Intl.DateTimeFormat('hu-HU', { month: 'short', day: 'numeric' }).format(d) + ' ' + time;
    } catch (e) {
      return '';
    }
  }
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return false; });
    return Promise.resolve(false);
  }
  function copyButton(code, cls) {
    var t = texts();
    var b = el('button', cls, t.copy_button);
    b.type = 'button';
    b.addEventListener('click', function () {
      copyText(code).then(function () {
        b.textContent = texts().copied;
        setTimeout(function () {
          b.textContent = texts().copy_button;
        }, 2000);
      });
    });
    return b;
  }
  // the platform's defaults (src/lib/wheel/schema.ts): a text the settings lack never shows as "undefined"
  var DEFAULTS = {
    title: 'Pörgess és nyerj kedvezményeket!',
    guiding: 'Minden pörgetés nyer. A kódot a kosaradba tesszük, 24 óráig érvényes.',
    subscribe: 'A pörgetéssel feliratkozol a Kenguru Gold hírlevelére. Bármikor leiratkozhatsz.',
    privacy_link: 'Adatkezelési tájékoztató',
    email_placeholder: 'pelda@email.hu',
    spin_button: 'Pörgetek',
    spinning: 'Pörög…',
    close_button: 'Most nem',
    invalid_email: 'Adj meg egy érvényes e-mail-címet.',
    too_many: 'Túl sok próbálkozás. Várj egy kicsit, és próbáld újra.',
    won_title: 'Nyertél: {prize}!',
    valid_line: 'A kód már a kosaradban van. Lejár: {until}.',
    use_now: 'Vásárolok',
    auto_applied: 'A fizetésnél automatikusan érvényesül.',
    losing_title: 'Most nem jött össze, legközelebb biztosan!',
    copy_button: 'Másolás',
    copied: 'Kimásolva',
    tab_kicker: 'Pörgesd meg a kereket',
    tab_main: 'Nyerj akár {max}%-ot',
    tab_main_plain: 'Nyerj kedvezményt',
    tab_hide: 'Elrejtés 3 napra',
    bar_hide: 'Elrejtés',
    chip: 'Kódod',
    valid_until: 'lejár: {until}',
    error: 'Most nem sikerült, próbáld újra egy perc múlva.',
  };
  var merged = null;
  function texts() {
    if (!config) return DEFAULTS;
    if (!merged) {
      merged = {};
      for (var k in DEFAULTS) merged[k] = config.texts && typeof config.texts[k] === 'string' && config.texts[k] ? config.texts[k] : DEFAULTS[k];
    }
    return merged;
  }
  function icon(path, size) {
    var s = svg('svg', { viewBox: '0 0 24 24', width: String(size || 13), height: String(size || 13), fill: 'none', stroke: 'currentColor', 'stroke-width': '2.4', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' });
    s.appendChild(svg('path', { d: path }));
    return s;
  }
  var X_PATH = 'M18 6 6 18M6 6l12 12';
  var GIFT_PATH = 'M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z';

  // ---------- the wheel graphic (wheel-graphic.tsx) ----------
  var SIZE = 400;
  var C = SIZE / 2;
  var RIM = 196;
  var FACE = 182;
  var LABEL_RADIUS = 118;
  function point(radius, degrees) {
    var r = (degrees * Math.PI) / 180;
    return [(C + radius * Math.sin(r)).toFixed(2), (C - radius * Math.cos(r)).toFixed(2)];
  }
  function sliceDeg() {
    return 360 / config.slices.length;
  }
  function sliceCentre(i) {
    return i * sliceDeg() + sliceDeg() / 2;
  }
  function normalise(d) {
    return ((d % 360) + 360) % 360;
  }
  // the readable turn for text along a radius at screen angle φ (from the top): never upside down
  function readable(phi) {
    var a = normalise(phi);
    return a <= 180 ? a - 90 : a - 270;
  }
  function uprightCorrection(i, rest) {
    var onScreen = readable(sliceCentre(i)) + rest;
    var wanted = readable(sliceCentre(i) + rest);
    var turn = normalise(wanted - onScreen);
    return turn > 180 ? turn - 360 : turn;
  }
  // what a slice says on the face: "5%" big, other prizes in two short lines
  function faceLabel(s) {
    if (s.kind === 'percent' && s.percent) return { lines: [Math.round(s.percent) + '%'], big: true };
    var words = String(s.label).replace(/\s+/g, ' ').trim().split(' ');
    if (words.length === 1) return { lines: words, big: false };
    var best = 1;
    var bestDiff = Infinity;
    for (var cut = 1; cut < words.length; cut++) {
      var diff = Math.abs(words.slice(0, cut).join(' ').length - words.slice(cut).join(' ').length);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = cut;
      }
    }
    return { lines: [words.slice(0, best).join(' '), words.slice(best).join(' ')], big: false };
  }
  function face(mini) {
    var root = svg('svg', { class: mini ? 'kgw-mini' : 'kgw-face', viewBox: '0 0 ' + SIZE + ' ' + SIZE, 'aria-hidden': 'true', focusable: 'false' });
    root.appendChild(svg('circle', { class: 'kgw-face__rim', cx: C, cy: C, r: RIM }));
    var labels = [];
    var slices = [];
    config.slices.forEach(function (s, i) {
      var start = i * sliceDeg();
      var end = start + sliceDeg();
      var dark = i % 2 === 1;
      var a = point(FACE, start);
      var b = point(FACE, end);
      var g = svg('g', {});
      var path = svg('path', { class: 'kgw-face__slice' + (dark ? ' kgw-face__slice--dark' : ''), d: 'M ' + C + ' ' + C + ' L ' + a[0] + ' ' + a[1] + ' A ' + FACE + ' ' + FACE + ' 0 0 1 ' + b[0] + ' ' + b[1] + ' Z' });
      g.appendChild(path);
      slices.push(path);
      if (!mini) {
        var at = point(LABEL_RADIUS, sliceCentre(i));
        var place = svg('g', { transform: 'translate(' + at[0] + ' ' + at[1] + ')' });
        var label = faceLabel(s);
        var text = svg('text', { class: 'kgw-face__label' + (dark ? ' kgw-face__label--dark' : '') + (label.big ? '' : ' kgw-face__label--small'), 'text-anchor': 'middle', 'dominant-baseline': 'central' });
        text.style.transform = 'rotate(' + readable(sliceCentre(i)) + 'deg)';
        if (label.lines.length === 1) text.textContent = label.lines[0];
        else
          label.lines.forEach(function (line, k) {
            var span = svg('tspan', { x: '0', dy: k === 0 ? '-0.55em' : '1.1em' });
            span.textContent = line;
            text.appendChild(span);
          });
        place.appendChild(text);
        g.appendChild(place);
        labels.push(text);
      }
      root.appendChild(g);
    });
    if (!mini) {
      config.slices.forEach(function (s, i) {
        var p = point((RIM + FACE) / 2, i * sliceDeg());
        root.appendChild(svg('circle', { class: 'kgw-face__dot', cx: p[0], cy: p[1], r: '3.6' }));
      });
    } else {
      root.appendChild(svg('circle', { class: 'kgw-face__hub', cx: C, cy: C, r: '52' }));
    }
    return { node: root, labels: labels, slices: slices };
  }
  function hub(id) {
    var root = svg('svg', { class: 'kgw-hub', viewBox: '0 0 ' + SIZE + ' ' + SIZE, 'aria-hidden': 'true', focusable: 'false' });
    root.appendChild(svg('circle', { class: 'kgw-face__hub', cx: C, cy: C, r: '46' }));
    if (MARK) {
      var clip = svg('clipPath', { id: id });
      clip.appendChild(svg('circle', { cx: C, cy: C, r: '38' }));
      root.appendChild(clip);
      root.appendChild(svg('image', { href: MARK, x: C - 38, y: C - 38, width: '76', height: '76', 'clip-path': 'url(#' + id + ')', preserveAspectRatio: 'xMidYMid slice' }));
    } else {
      root.appendChild(svg('circle', { class: 'kgw-face__hub-dot', cx: C, cy: C, r: '14' }));
    }
    return root;
  }
  function pointer() {
    var root = svg('svg', { class: 'kgw-pointer', viewBox: '0 0 40 48', 'aria-hidden': 'true', focusable: 'false' });
    root.appendChild(svg('path', { d: 'M20 46 C 17 40, 5 22, 5 16 A 15 15 0 0 1 35 16 C 35 22, 23 40, 20 46 Z' }));
    root.appendChild(svg('circle', { cx: '20', cy: '16', r: '5.5' }));
    return root;
  }

  // ---------- the navbar's part: the tab, the code bar, its chip ----------
  var hang = null;
  var nudged = false;
  function headerHost() {
    return document.querySelector('.shopify-section--header') || document.querySelector('header') || null;
  }
  function renderHang() {
    var host = headerHost();
    if (!host) return;
    if (!hang) {
      hang = el('div', 'kgw-hang');
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(hang);
    }
    hang.textContent = '';
    // nothing hangs from the bar while the dialog is open
    if (layer) return;
    var t = texts();
    var w = readWin();
    if (w) {
      if (local(BAR_HIDDEN_KEY) === w.code) {
        var chip = el('button', 'kgw-codechip');
        chip.type = 'button';
        chip.setAttribute('aria-label', t.chip);
        chip.appendChild(icon(GIFT_PATH, 15));
        chip.appendChild(el('span', null, t.chip));
        chip.addEventListener('click', function () {
          local(BAR_HIDDEN_KEY, null);
          renderHang();
        });
        hang.appendChild(chip);
        return;
      }
      var bar = el('div', 'kgw-bar');
      bar.appendChild(el('span', 'kgw-bar__prize', w.label));
      bar.appendChild(el('span', 'kgw-bar__code', w.code));
      bar.appendChild(el('span', 'kgw-bar__time', fill(t.valid_until, { until: until(w.until) })));
      bar.appendChild(copyButton(w.code, 'kgw-bar__copy'));
      var hide = el('button', 'kgw-bar__hide');
      hide.type = 'button';
      hide.setAttribute('aria-label', t.bar_hide);
      hide.title = t.bar_hide;
      hide.appendChild(icon(X_PATH));
      hide.addEventListener('click', function () {
        local(BAR_HIDDEN_KEY, w.code);
        renderHang();
      });
      bar.appendChild(hide);
      hang.appendChild(bar);
      return;
    }
    if (!config || wheelioActive() || Number(local(TAB_HIDDEN_KEY) || 0) > Date.now()) return;
    var tab = el('div', 'kgw-tab');
    if (!nudged && session(NUDGE_KEY) === null) {
      tab.className += ' kgw-tab--nudge';
      session(NUDGE_KEY, '1');
    }
    nudged = true;
    var open = el('button', 'kgw-tab__open');
    open.type = 'button';
    open.setAttribute('aria-haspopup', 'dialog');
    open.setAttribute('aria-label', t.title);
    var mini = el('span', 'kgw-tab__wheel');
    mini.setAttribute('aria-hidden', 'true');
    mini.appendChild(face(true).node);
    open.appendChild(mini);
    var words = el('span', 'kgw-tab__text');
    words.appendChild(el('span', 'kgw-tab__kicker', t.tab_kicker));
    // Voovo's tab: the big number, "Nyerj akár 30%-ot" (the biggest percent a spin can really win)
    var max = config && typeof config.maxPercent === 'number' ? Math.round(config.maxPercent) : null;
    words.appendChild(el('span', 'kgw-tab__main', max ? fill(t.tab_main, { max: max }) : t.tab_main_plain));
    open.appendChild(words);
    open.addEventListener('click', function () {
      openDialog('tab');
    });
    var hideTab = el('button', 'kgw-tab__hide');
    hideTab.type = 'button';
    hideTab.setAttribute('aria-label', t.tab_hide);
    hideTab.title = t.tab_hide;
    hideTab.appendChild(icon(X_PATH));
    hideTab.addEventListener('click', function () {
      local(TAB_HIDDEN_KEY, String(Date.now() + TAB_HIDE_DAYS * 86400000));
      renderHang();
    });
    tab.appendChild(open);
    tab.appendChild(hideTab);
    hang.appendChild(tab);
  }

  // ---------- the dialog (discount-wheel.tsx WheelDialog) ----------
  var dialog = null;
  var layer = null;
  function closeDialog(byVisitor) {
    if (!layer) return;
    if (byVisitor && dialog && dialog.phase !== 'result') beacon('closed');
    clearTimeout(dialog && dialog.timer);
    var l = layer;
    layer = null;
    dialog = null;
    l.classList.remove('kgw-open');
    document.documentElement.classList.remove('kgw-lock');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () {
      l.remove();
    }, 220);
    renderHang();
  }
  function onKey(e) {
    if (e.key === 'Escape' && dialog && dialog.phase !== 'spinning') closeDialog(true);
  }

  function openDialog(openedBy) {
    if (layer || !config) return;
    var t = texts();
    beacon('shown');
    if (openedBy !== 'tab') setCookie(SEEN_COOKIE, '1', config.cookieDays);
    dialog = { phase: 'form', rotation: 0, timer: 0 };
    layer = el('div', 'kgw');
    var overlay = el('div', 'kgw-overlay');
    overlay.addEventListener('click', function () {
      if (dialog && dialog.phase !== 'spinning') closeDialog(true);
    });
    var box = el('div', 'kgw-dialog kgw-dialog--form');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', t.title);

    var stage = el('div', 'kgw-stage');
    var wheel = el('div', 'kgw-wheel');
    wheel.setAttribute('role', 'img');
    wheel.setAttribute('aria-label', 'Szerencsekerék');
    var disc = el('div', 'kgw-wheel__disc');
    var spin = el('div', 'kgw-wheel__spin');
    var drawn = face(false);
    spin.appendChild(drawn.node);
    disc.appendChild(spin);
    wheel.appendChild(disc);
    wheel.appendChild(hub('kgw-mark-' + Date.now()));
    wheel.appendChild(pointer());
    stage.appendChild(wheel);

    var body = el('div', 'kgw-body');
    var close = el('button', 'kgw-close');
    close.type = 'button';
    close.setAttribute('aria-label', t.close_button);
    close.appendChild(icon(X_PATH, 20));
    close.addEventListener('click', function () {
      if (dialog && dialog.phase !== 'spinning') closeDialog(true);
    });

    box.appendChild(stage);
    box.appendChild(body);
    box.appendChild(close);
    layer.appendChild(overlay);
    layer.appendChild(box);
    // the sizes follow the screen as it is when the dialog opens: a phone's keyboard (the e-mail field) makes the
    // screen shorter, and nothing in the dialog may change size for that
    var h = window.innerHeight;
    box.style.setProperty('--kgw-h', h + 'px');
    if (h <= 600) box.classList.add('kgw-short-desk');
    if (h <= 700) box.classList.add('kgw-short-phone');
    document.body.appendChild(layer);
    document.documentElement.classList.add('kgw-lock');
    document.addEventListener('keydown', onKey);
    renderHang();
    requestAnimationFrame(function () {
      if (layer) layer.classList.add('kgw-open');
    });
    formView(body, box, spin, drawn);
  }

  function formView(body, box, spin, drawn) {
    var t = texts();
    body.textContent = '';
    body.appendChild(el('h2', 'kgw-title', t.title));
    body.appendChild(el('p', 'kgw-sub', t.guiding));
    var form = el('form', 'kgw-form');
    form.noValidate = true;
    var email = el('input', 'kgw-input');
    email.type = 'email';
    email.name = 'email';
    email.autocomplete = 'email';
    email.inputMode = 'email';
    email.placeholder = t.email_placeholder;
    email.setAttribute('aria-label', t.email_placeholder);
    var hp = el('input');
    hp.type = 'text';
    hp.name = 'company';
    hp.tabIndex = -1;
    hp.autocomplete = 'off';
    var hpBox = el('div', 'kgw-hp');
    hpBox.setAttribute('aria-hidden', 'true');
    hpBox.appendChild(hp);
    var error = el('p', 'kgw-error');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    var button = el('button', 'kgw-primary', t.spin_button);
    button.type = 'submit';
    var notice = el('p', 'kgw-notice', t.subscribe + ' ');
    var privacy = el('a', null, t.privacy_link);
    privacy.href = PRIVACY;
    privacy.target = '_blank';
    privacy.rel = 'noopener';
    notice.appendChild(privacy);
    form.appendChild(email);
    form.appendChild(hpBox);
    form.appendChild(error);
    form.appendChild(button);
    form.appendChild(notice);
    body.appendChild(form);
    var quiet = el('button', 'kgw-quiet', t.close_button);
    quiet.type = 'button';
    quiet.addEventListener('click', function () {
      closeDialog(true);
    });
    body.appendChild(quiet);
    setTimeout(function () {
      // a phone's keyboard must not jump up by itself
      if (layer && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) email.focus({ preventScroll: true });
    }, 300);

    function fail(message) {
      dialog.phase = 'form';
      box.classList.remove('kgw-dialog--spinning', 'kgw-dialog--result'); box.classList.add('kgw-dialog--form');
      error.textContent = message;
      error.hidden = false;
      button.disabled = false;
      email.disabled = false;
      button.textContent = t.spin_button;
      quiet.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!dialog || dialog.phase !== 'form') return;
      var value = email.value.trim().toLowerCase();
      if (!/^[^\s@,;<>"]+@[^\s@,;<>"]+\.[a-z]{2,}$/.test(value)) {
        error.textContent = t.invalid_email;
        error.hidden = false;
        email.setAttribute('aria-invalid', 'true');
        email.focus();
        return;
      }
      email.removeAttribute('aria-invalid');
      error.hidden = true;
      dialog.phase = 'spinning';
      box.classList.remove('kgw-dialog--form', 'kgw-dialog--result'); box.classList.add('kgw-dialog--spinning');
      button.disabled = true;
      email.disabled = true;
      button.textContent = t.spinning;
      quiet.hidden = true;
      post({ action: 'spin', email: value, page: location.pathname, website: hp.value })
        .then(function (res) {
          if (!dialog) return;
          if (!res || res.error || typeof res.slice !== 'number') return fail(res && res.error === 'invalid_email' ? t.invalid_email : res && res.error === 'too_many' ? t.too_many : t.error);
          if (res.win && res.code) {
            var endsAt = res.endsAt ? Date.parse(res.endsAt) : Date.now() + 86400000;
            local(WIN_KEY, JSON.stringify({ code: res.code, label: res.label, until: endsAt }));
            local(BAR_HIDDEN_KEY, null);
            applyCode(res.code);
          }
          spinTo(res.slice, spin, drawn, function () {
            resultView(body, box, res);
          });
        })
        .catch(function () {
          if (dialog) fail(t.error);
        });
    });
  }

  // where the wheel stops for the drawn slice: a little off its centre, after five full turns (landing())
  function spinTo(index, spin, drawn, done) {
    var margin = 5;
    var offset = (Math.random() * 2 - 1) * (sliceDeg() / 2 - margin);
    var angle = sliceCentre(index) + offset;
    var current = dialog.rotation;
    var settle = normalise(-angle - current);
    var target = current + SPIN_TURNS * 360 + settle;
    dialog.rotation = target;
    function finish() {
      if (!dialog) return;
      clearTimeout(dialog.timer);
      spin.style.transition = 'none';
      drawn.slices[index].classList.add('kgw-face__slice--won');
      // labels the stop left upside down flip about their own centre (CSS animates it)
      drawn.labels.forEach(function (label, i) {
        label.style.transform = 'rotate(' + (readable(sliceCentre(i)) + uprightCorrection(i, target)) + 'deg)';
      });
      dialog.phase = 'result';
      done();
    }
    if (reducedMotion()) {
      spin.style.transform = 'rotate(' + target + 'deg)';
      return finish();
    }
    spin.style.transition = 'transform ' + SPIN_MS + 'ms cubic-bezier(0.12, 0.72, 0.16, 1)';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        spin.style.transform = 'rotate(' + target + 'deg)';
      });
    });
    spin.addEventListener('transitionend', function handler(e) {
      if (e.target !== spin) return;
      spin.removeEventListener('transitionend', handler);
      finish();
    });
    dialog.timer = setTimeout(finish, SPIN_MS + 600);
  }

  function resultView(body, box, res) {
    var t = texts();
    box.classList.remove('kgw-dialog--form', 'kgw-dialog--spinning'); box.classList.add('kgw-dialog--result');
    body.textContent = '';
    var result = el('div', 'kgw-result');
    if (!res.win || !res.code) {
      result.appendChild(el('h2', 'kgw-title', t.losing_title));
      var ok = el('button', 'kgw-primary', t.close_button);
      ok.type = 'button';
      ok.addEventListener('click', function () {
        closeDialog(false);
      });
      result.appendChild(ok);
      body.appendChild(result);
      return;
    }
    var endsAt = res.endsAt ? Date.parse(res.endsAt) : Date.now() + 86400000;
    result.appendChild(el('h2', 'kgw-title', fill(t.won_title, { prize: res.label })));
    var chip = el('div', 'kgw-chip');
    chip.appendChild(el('span', 'kgw-chip__code', res.code));
    var copy = copyButton(res.code, 'kgw-chip__copy');
    chip.appendChild(copy);
    result.appendChild(chip);
    result.appendChild(el('p', 'kgw-sent', fill(t.valid_line, { until: until(endsAt) })));
    var use = el('button', 'kgw-primary', t.use_now);
    use.type = 'button';
    use.addEventListener('click', function () {
      closeDialog(false);
      cartCount().then(function (n) {
        if (n > 0) location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
      });
    });
    result.appendChild(use);
    result.appendChild(el('p', 'kgw-note', t.auto_applied));
    body.appendChild(result);
    copy.focus({ preventScroll: true });
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function cartCount() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        return c.item_count || 0;
      })
      .catch(function () {
        return 0;
      });
  }
  // added to the cart's codes the way the theme's own discount field does it (/cart/update.js), so a code already in
  // the cart stays; /discount/<code> would replace it
  function applyCode(code) {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) {
          return d.code;
        });
        if (codes.indexOf(code) === -1) codes.push(code);
        return fetch(root() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        return fetch(root() + 'discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
      });
  }

  // Wheelio, while its campaign is still on, runs its own wheel: never two. Its settings arrive only for an active
  // campaign (and for its countries), so an empty appWlo.Settings means Wheelio shows nothing here.
  function wheelioActive() {
    try {
      var w = window.appWlo;
      return !!(w && w.Settings && Object.keys(w.Settings).length);
    } catch (e) {
      return false;
    }
  }

  // ---------- when it opens by itself: exactly Wheelio's "user intent" (its SetAppExitIntent) ----------
  //   desktop: the pointer leaves the page through the top (mouseleave on <html>, clientY < 0), from the first second;
  //   phone: from the first touchmove, checked every second: scrolled down more than 50 % of the page's height, then
  //   back up more than 10 % of it. Once per page; not while a won code lives; not again for cookie_days once shown.
  function arm() {
    if (preview) return openDialog('preview');
    if (getCookie(SEEN_COOKIE) || readWin()) return;
    var fired = false;
    function fire() {
      if (fired || layer || wheelioActive() || getCookie(SEEN_COOKIE) || readWin()) return;
      fired = true;
      openDialog('exit');
    }
    var root = document.documentElement;
    function onLeave(e) {
      if (e.clientY < 0) {
        root.removeEventListener('mouseleave', onLeave);
        fire();
      }
    }
    root.addEventListener('mouseleave', onLeave);
    function scrollTop() {
      return root.scrollTop || document.body.scrollTop || window.scrollY || 0;
    }
    // Wheelio's watcher: from where it starts, the distance in one direction, measured against the page's height
    function watch(down, percent, done) {
      var from = scrollTop();
      var height = document.body.offsetHeight;
      if (height <= 0) return;
      var timer = setInterval(function () {
        var moved = down ? scrollTop() - from : from - scrollTop();
        if (moved < 0) {
          moved = 0;
          from = scrollTop();
        }
        if (moved / height > percent / 100) {
          clearInterval(timer);
          done();
        }
      }, 1000);
    }
    function onTouch() {
      root.removeEventListener('touchmove', onTouch);
      watch(true, 50, function () {
        watch(false, 10, fire);
      });
    }
    root.addEventListener('touchmove', onTouch, { passive: true });
  }

  function start() {
    renderHang();
    post({ action: 'config', preview: preview })
      .then(function (res) {
        if (!res || !res.open || !res.config) return;
        config = res.config;
        // Wheelio's settings arrive a moment after the page: the tab waits for them, and goes if they come later still
        setTimeout(renderHang, 1500);
        var checks = 0;
        var watch = setInterval(function () {
          if (hang && hang.querySelector('.kgw-tab') && wheelioActive()) renderHang();
          if (++checks >= 10) clearInterval(watch);
        }, 2000);
        arm();
      })
      .catch(function () {});
    // a won code runs out while the page is open: the bar goes
    setInterval(function () {
      if (hang && hang.querySelector('.kgw-bar, .kgw-codechip') && !readWin()) renderHang();
    }, 60000);
  }

  var later = window.requestIdleCallback || function (fn) {
    return setTimeout(fn, 1200);
  };
  if (document.readyState === 'complete') later(start);
  else
    window.addEventListener('load', function () {
      later(start);
    });
})();
